import type { RouteLocationNormalized, RouteRecordRaw } from 'vue-router'

export const launchAdminRouter: RouteRecordRaw[] = [
  {
    children: [
      {
        component: async () => import('../views/LaunchAdminListView.vue'),
        meta: {
          roles: ['pb:super'],
          title: 'launch.dashboard',
        },
        name: 'admin.launch',
        path: '',
      },
      {
        component: async () => import('../views/LaunchAdminBrandView.vue'),
        meta: {
          roles: ['pb:super'],
          title: 'launch.dashboard',
        },
        name: 'admin.launch.brand',
        path: 'brands/:brandId',
        props: (route: RouteLocationNormalized) => ({
          brandId: route.params.brandId,
        }),
      },
    ],
    component: async () => import('../views/LaunchAdminView.vue'),
    meta: {
      roles: ['pb:super'],
    },
    path: 'admin/launch',
  },
]
